"use client";

interface YesNoGateProps {
  onYes: () => void;
  onNo: () => void;
  /** Which option is currently chosen, for callers that keep both the gate and the revealed
   *  follow-up content on the same screen (e.g. Dates' flexibility screen). Omit when the click
   *  itself immediately navigates away — there's nothing to show as selected in that case. */
  selected?: "yes" | "no" | null;
}

const BASE_CLASSES =
  "flex-1 py-4 px-6 rounded-xl border-2 text-base font-medium transition-all hover:border-indigo-400 hover:bg-indigo-50/50";
const SELECTED_CLASSES = "border-indigo-500 bg-indigo-50 text-indigo-700";
const UNSELECTED_CLASSES = "border-gray-200 text-gray-800";

/** Paired Yes/No card-style buttons for binary gate questions. */
export const YesNoGate = ({ onYes, onNo, selected = null }: YesNoGateProps) => (
  <div className="flex gap-3">
    <button
      type="button"
      onClick={onYes}
      aria-pressed={selected === "yes"}
      className={`${BASE_CLASSES} ${selected === "yes" ? SELECTED_CLASSES : UNSELECTED_CLASSES}`}
    >
      Yes
    </button>
    <button
      type="button"
      onClick={onNo}
      aria-pressed={selected === "no"}
      className={`${BASE_CLASSES} ${selected === "no" ? SELECTED_CLASSES : UNSELECTED_CLASSES}`}
    >
      No
    </button>
  </div>
);
